module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/ma-gallery/ma-gallery-10-1834b9de722d01739705aabd878e8e57.jpg";